import React, { useState } from "react";
import "./Title.css";
import { TextField, Button, Box, Grid, IconButton } from "@mui/material";
import StickyHeadTable from "../StickyHeadTable/StickyHeadTable.js";

const SubmitTitle = () => {
  const [title, setTitle] = useState("");
  const [results, setResults] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResults(null);

    if (title.trim() === "") return;

    // If no errors, submit the form

    try {
      const response = await fetch(
        `https://ajayreddy9-prgi.hf.space/titles/${title}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setResults(data);
        console.log(data);
      } else {
        console.error("Failed to fetch results");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <section className="title-page">
        <h1>Search Title</h1>
        {/* Form verify Title*/}
        <div className="form-container">
          <Box sx={{ maxWidth: 900, margin: "auto", mt: 4 }}>
            <form className="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                sx={{ maxWidth: 400 }}
                label={`Enter Title`}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                variant="outlined"
              />

              <Button type="submit" variant="contained" color="primary">
                Search
              </Button>
            </form>
          </Box>
          {results !== null && (
            <section className="search-results">
              <h2 className="heading">Results</h2>
              <StickyHeadTable similar_titles={results} />
            </section>
          )}
        </div>
      </section>
    </>
  );
};

export default SubmitTitle;
